<template>
  <label class="switch">
    <input :name="name" @click="toggle" :checked="checked" type="checkbox" />
    <span class="slider round"></span>
  </label>
</template>
<script>
export default {
  props: ["checked", "name"],
  methods: {
    toggle(ev) {
      this.$emit("toggle", {
        value: ev.target.checked,
        name: this.name
      });
    }
  }
};
</script>
